export default {"src":"/_next/static/media/dift-full-black.f121fa72.svg","height":56,"width":137,"blurWidth":0,"blurHeight":0};